import React from 'react';
import './AccountNavLink.scss';
import cx from 'classnames';

const AccountNavLink = ({ children, modifierClass }) => {
	const classNames = cx('onboarding-nav-link', modifierClass);
	return <div className={classNames}>{children}</div>;
};

export default AccountNavLink;
